import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setNomeConsultaAdvertenciaFornecedor: ['nome'],
    setCpfConsultaAdvertenciaFornecedor: ['cpf'],
    setCnpjConsultaAdvertenciaFornecedor: ['cnpj'],
    limpaFiltroConsultaAdvertenciaFornecedor: [],
    receberFiltroConsultaAdvertenciaFornecedor: ['filtroRecebido'],
    setStatusConsultaAdvertenciaFornecedor: ['status'],
})

const INITIAL_STATE = {
    nome: '',
    cpf: '',
    cnpj: '',
    status: { label: '', value: '' },
}

const setNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: action.nome }
}

const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}

const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_NOME_CONSULTA_ADVERTENCIA_FORNECEDOR]: setNome,
    [Types.SET_CPF_CONSULTA_ADVERTENCIA_FORNECEDOR]: setCpf,
    [Types.SET_CNPJ_CONSULTA_ADVERTENCIA_FORNECEDOR]: setCnpj,
    [Types.LIMPA_FILTRO_CONSULTA_ADVERTENCIA_FORNECEDOR]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_ADVERTENCIA_FORNECEDOR]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_ADVERTENCIA_FORNECEDOR]: setStatus,
})
